import { Text, View } from '@react-pdf/renderer';

import { VehicleInspectionReportExtraDetailsRead } from 'src/common/external/bambi-api/bambiApi';
import { commonStyles } from 'src/common/pdf/common.styles';
import { formatFullName } from 'src/common/util/formatFullName';

interface VehicleInspectionReportDriverSectionProps {
  driver: VehicleInspectionReportExtraDetailsRead['membership'];
}
export function VehicleInspectionReportDriverSection({
  driver,
}: VehicleInspectionReportDriverSectionProps) {
  return (
    <View style={{ width: '100%' }}>
      <Text style={commonStyles.strong}>Driver - {formatFullName(driver)}</Text>
      <View style={[commonStyles.rowBg, { padding: 6 }]}>
        <Text>
          Driver License Number:{' '}
          <Text style={commonStyles.strong}>{driver.license_number}</Text>
        </Text>
      </View>
      <View style={[commonStyles.rowBgAlt, { padding: 6 }]}>
        <Text>
          Driver License State:{' '}
          <Text style={commonStyles.strong}>{driver.license_state}</Text>
        </Text>
      </View>
    </View>
  );
}
